var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElectric = function SvgElectric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#electric_svg__a)",
    fillRule: "evenodd",
    d: "M10 21a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2 2 2 0 1 1-4 0h-8a2 2 0 1 1-4 0 2 2 0 0 1-2-2zm3 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2m15-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#electric_svg__b)",
    fillRule: "evenodd",
    d: "M12.579 17H27.42l-1.116-2.975A1.58 1.58 0 0 0 24.827 13h-9.654c-.658 0-1.247.408-1.478 1.025z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#electric_svg__c)",
    fillRule: "evenodd",
    d: "M3 20c0-9.388 7.611-17 17-17 1.813 0 3.559.284 5.195.809a1 1 0 0 0 .61-1.905A19 19 0 0 0 20 1C9.507 1 1 9.507 1 20s8.507 19 19 19 19-8.506 19-19q0-.798-.065-1.582a1 1 0 0 0-1.993.165Q37 19.283 37 20c0 9.388-7.611 17-17 17S3 29.389 3 20M34.888 3.46a1 1 0 1 0-1.776-.919l-3 5.796A1 1 0 0 0 31 9.797h3.297l-.295.529-2.057 3.687a1 1 0 1 0 1.746.974l2.057-3.687.803-1.439.236-.424.064-.114.017-.03.004-.007v-.002h.001L36 8.795l.873.487A1 1 0 0 0 36 7.796h-3.356z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "electric_svg__a",
    x1: 20,
    x2: 20,
    y1: 27,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "electric_svg__b",
    x1: 20,
    x2: 20,
    y1: 17,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "electric_svg__c",
    x1: 20,
    x2: 20,
    y1: 39.001,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgElectric;